import { Pill } from "@dashboard/components/Pill";
import React from "react";
import { useIntl } from "react-intl";

import { complianceMessages } from "../../messages";

interface WsmYesNoProps {
  value: boolean;
  /**
   * "warning" is for a yes that is a caution rather than a win: a product that
   * carries a Proposition 65 warning is not a green state.
   */
  tone?: "plain" | "warning";
}

/**
 * Every Yes/No cell in the section, as the pill Orders and Products use for
 * Published/Draft. One component so Required on one list and Prop 65 on the
 * next cannot drift into two shapes.
 */
export const WsmYesNo = ({ value, tone = "plain" }: WsmYesNoProps) => {
  const intl = useIntl();

  return (
    <Pill
      color={value ? (tone === "warning" ? "warning" : "success") : "info"}
      label={intl.formatMessage(value ? complianceMessages.yes : complianceMessages.no)}
    />
  );
};

export default WsmYesNo;
